import * as React from 'react';
import { ChevronDown } from '@wix/wix-ui-icons-common/on-stage';
import { Button } from '../Button';
import { TPAComponentProps } from '../../types';
import { DATA_HOOKS } from './constants';
import { st, classes } from './DropdownBase.st.css';
import { DropdownBaseProps } from './types';
import { Spinner, SpinnerTypes } from '../Spinner';

export const DropdownBase = React.forwardRef<
  HTMLButtonElement,
  DropdownBaseProps & TPAComponentProps
>(
  (
    props: DropdownBaseProps & TPAComponentProps,
    ref: React.RefObject<HTMLButtonElement>,
  ) => {
    const {
      selectedOption,
      placeholder,
      error,
      disabled,
      upgrade,
      className,
      isExpanded,
      id: dropdownId,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      'aria-activedescendant': ariaActivedescendant,
      'aria-describedby': ariaDescribedBy,
      'aria-required': ariaRequired,
      'aria-controls': ariaControls,
      rtl,
      isLoading,
      'loading-aria-label': loadingAriaLabel,
    } = props;
    const hasPlaceholder = !selectedOption || !selectedOption.value;

    return (
      <Button
        upgrade={upgrade}
        fullWidth
        className={st(
          classes.root,
          { error, placeholder: hasPlaceholder, upgrade, rtl },
          className,
        )}
        data-hook={DATA_HOOKS.base}
        data-dropdown-base-error={error}
        disabled={disabled}
        aria-activedescendant={ariaActivedescendant}
        aria-expanded={isExpanded}
        id={dropdownId}
        ref={ref}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
        aria-required={ariaRequired}
        aria-invalid={error}
        role="combobox"
        aria-controls={ariaControls}
        prefixIcon={
          selectedOption && selectedOption.icon ? (
            <div className={classes.optionIcon}>{selectedOption.icon}</div>
          ) : null
        }
        suffixIcon={
          <>
            {isLoading ? (
              <Spinner
                className={classes.loader}
                data-hook={DATA_HOOKS.loader}
                type={SpinnerTypes.slim}
                aria-label={loadingAriaLabel}
              />
            ) : (
              <ChevronDown className={classes.arrowIcon} />
            )}
          </>
        }
      >
        <div
          className={classes.childrenWrapper}
          data-hook={DATA_HOOKS.baseText}
        >
          {(selectedOption && selectedOption.value) || placeholder}
        </div>
      </Button>
    );
  },
);
